module.exports = __webpack_public_path__ + "static/media/iOSActivationUserGuide.c9a6f037.pdf";